export default __webpack_public_path__ + "static/media/template.acf73d72.csv";